import axios from "axios";
import oss from "./oss.js";
// import urls from "./urls.js";

/**
 * 上传单张图片
 * @param {object} params
 * @param {string} params.file 待上传的本地图片地址
 * @param {Function} params.success 上传成功的回调函数
 * @param {Function} params.fail 上传失败的回调函数
 */
function uploadSingle(params) {
    const { file, success, fail } = params;

    oss.getFormData(file)
        .then(res => {
            const { formData, uploadedFilename,host } = res;
            uploadFileToOSS(formData,host, function(error) {
                if (error) {
                    fail && fail(error);
                } else {
                    success && success(uploadedFilename);
                }
            });
        });
}

/**
 * 上传多张图片
 * @param {object} params
 * @param {Array} params.files
 * @param {Function} params.success
 * @param {Function} params.fail
 * @param {Function} params.complete
 */
function uploadMultiple(params) {
    if (!params) return;
    const { files, success=noop, fail=noop, complete=noop } = params;
    if (!files || files.length <= 0) {
        throw new Error("the uploading file pathes is empty!");
    }

    let loadingIndex = 0;
    const count = files.length;
    let remoteFilePaths = [];

    uploadAt(loadingIndex, uploadNext);

    function uploadAt(idx, callback) {
        if (idx >= count) return;

        const file = files[idx];
        uploadSingle({
            file,
            success: res => {
                remoteFilePaths.push(res);
                callback();
            },
            fail: err => {
                fail(err);
            }
        })
    }

    function uploadNext() {
        loadingIndex++;
        if (loadingIndex >= count) {
            success(remoteFilePaths);
            complete();
        } else {
            uploadAt(loadingIndex, uploadNext);
        }
    }
}

/**
 * 上传文件至OSS
 * @param {Object} formData 上传的表单数据
 * @param {Function} next 回调函数
 */
function uploadFileToOSS(formData,host, next) {
    const url = host;

    const config = {
        headers: {
            "Content-Type": "multipart/form-data"
        }
    }

    axios.post(url, formData, config)
        .then(res => {
            if (res.status === 200) {
                next(null);
            } else {
                next("上传失败");
            }
        })
        .catch(err => {
            next(err);
        })
}

function noop() {}

export default {
    uploadMultiple,
}